import { observable }             from 'mobx'
import moment                     from 'moment'

import { API
       , JOB_STATUS
       , kde_api_job_t }          from '../02_api'
import { CRUD
       , FACTORY
       , Filter
       , filter_by_text
       }                          from '../09_model_app'
import { filter_by_client_name }  from '../23_screen_clients'


let g_jobs: MJobs ;


export class MJobs
{
  @observable public filter_status   : JOB_STATUS = JOB_STATUS.UNDEFINED ;

  filter_client  = Filter<string>( 'name', (opts: kde_api_job_t, txt: string ) => filter_by_client_name( opts.client, txt ) )
  filter_machine = Filter<string>( 'machine', (opts: kde_api_job_t, filter_text: string ) =>
                                 !opts.machine || filter_by_text( opts.machine.name, filter_text )
                         ) ;
  filter_date    = Filter<moment.Moment>( 'creationDate'
                         , (opts: kde_api_job_t, filter_text: moment.Moment ) =>
                              !filter_text || moment( opts.creationDate ).isSame( filter_text, 'date' )
                         , ( container, value ) =>
                             container.set( value )
                         ) ;
  filter_model   = Filter<string>( 'key.model', (opts: kde_api_job_t, filter_text: string ) =>
                                 !filter_text || filter_by_text( opts.key.model, filter_text )
                         ) ;


  jobs = new CRUD<kde_api_job_t>(
      user => API.JOBS( user? user.workgroup!.cloud.id : 0 )
    , user => 
       FACTORY.JOBS.data_fetcher_for( { cloud_id: user? user.workgroup!.cloud.id : 0 } )
    , data => 
       data.filter( entry => 
                    (this.filter_status === JOB_STATUS.UNDEFINED || entry.jobStatus.name === this.filter_status )
                && this.filter_client.pass_filter( entry )
                && this.filter_machine.pass_filter( entry )
                && this.filter_date.pass_filter( entry )
                && this.filter_model.pass_filter( entry ) )
    ) ;

  on_change_filter_status = ( value: any ) =>
    this.filter_status = value ;


  public static instance ( )
  {
    if ( !g_jobs )
          g_jobs = new MJobs( ) ;

    return g_jobs ;
  }
}